
import { useState, CSSProperties } from "react";
import { HeaderShell } from "../headerShell";
import { MobileMenu } from "../mobileMenu";
import { headerLinks } from "../headerLinks";
import './css/header.css'

interface HeaderProps {
    logoSrc: string;
    title?: string | JSX.Element;
    subtitle?: string;
    ctaLabel?: string;
    ctaHref?: string;
    headerIconStyle?: CSSProperties;
    headerIconClassName?: string;
    DisplayNavMenu?: Boolean;
}

export const Header = (props: HeaderProps) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const displayNameMenu: Boolean = props.DisplayNavMenu ?? true;
    return (
        <>
            <HeaderShell
                logoSrc={props.logoSrc}
                onBurgerClick={() => setMenuOpen(true)}
                showBurger={!menuOpen}
                headerIconStyle={props.headerIconStyle}
                headerIconClassName={props.headerIconClassName}
            >
                {(props.DisplayNavMenu ?? true) && (
                    <div className="header-nav w-100 d-flex justify-content-end mb-4">
                        {headerLinks.map((link) => (
                            <a
                                key={link.href}
                                href={link.href}
                                className="links me-3 text-white text-decoration-none"
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>
                )}

                {(props.title || props.subtitle) && (
                    <div className="mt-auto mb-auto">
                        {props.title && (
                            <h1
                                style={{
                                    fontSize: "clamp(2rem, 4vw, 5rem)", // responsive scaling
                                }}
                            >
                                {props.title}
                            </h1>
                        )}
                        {props.subtitle && (
                            <p
                                className="mt-3"
                                style={{
                                    fontSize: "clamp(1.2rem, 1.5vw, 1.5rem)", // responsive scaling
                                }}
                            >
                                {props.subtitle}
                            </p>
                        )}
                        {props.ctaLabel && props.ctaHref && (
                            <div className="mt-4 d-flex">
                                <a
                                    className="btn px-4 py-3 me-3 demo-button"
                                    href={props.ctaHref}
                                >
                                    {props.ctaLabel}
                                </a>
                            </div>
                        )}
                    </div>

                )}
            </HeaderShell>

            {menuOpen && (
                <MobileMenu onClose={() => setMenuOpen(false)} />
            )}
        </>
    );
};
